import { useSiteAboutStore } from "../siteAboutStore/siteAboutStore";

const BACKUP_AUTO_PATROL_SCHEDULES = "backupAutoPatrolSchedules";
const BACKUP_AUTO_PATROL_SCHEDULE_HEALTHCHCK_METRICS =
  "backupAutoPatrolScheduleHealthchckMetrics";
const BACKUP_AUTO_PATROL_CAMERA_PRODUCTS = "backupAutoPatrolCameraProducts";
const BACKUP_UPDATED_PRODUCT_METRICS_IDS = "backupUpdatedProductMetricsIds";

/**
 * Backs up auto patrol state to localStorage and calls setSchedulesEditMode(true).
 * Call when user clicks "Edit Schedules".
 */
export const handleEditSchedulesClick = (
  setSchedulesEditMode: (value: boolean) => void
) => {
  const {
    autoPatrolSchedules,
    autoPatrolScheduleHealthchckMetrics,
    autoPatrolCameraProducts,
    updatedProductMetricsIds,
  } = useSiteAboutStore.getState();

  localStorage.setItem(
    BACKUP_AUTO_PATROL_SCHEDULES,
    JSON.stringify(autoPatrolSchedules)
  );
  localStorage.setItem(
    BACKUP_AUTO_PATROL_SCHEDULE_HEALTHCHCK_METRICS,
    JSON.stringify(autoPatrolScheduleHealthchckMetrics)
  );
  localStorage.setItem(
    BACKUP_AUTO_PATROL_CAMERA_PRODUCTS,
    JSON.stringify(autoPatrolCameraProducts)
  );
  localStorage.setItem(
    BACKUP_UPDATED_PRODUCT_METRICS_IDS,
    JSON.stringify(updatedProductMetricsIds)
  );

  setSchedulesEditMode(true);
};

/**
 * Restores auto patrol state from localStorage, resets schedule-update flags,
 * and calls setSchedulesEditMode(false). Call when user clicks "Cancel" in Schedules edit mode.
 */
export const handleCancelSchedulesClick = (
  setSchedulesEditMode: (value: boolean) => void
) => {
  const {
    setAutoPatrolSchedules,
    setAutoPatrolScheduleHealthchckMetrics,
    setAutoPatrolCameraProducts,
    setUpdatedProductMetricsIds,
    setProductMetricsWereUpdated,
    setAutoPatrolSchedulesUpdatedBoolean,
    setUpdatedAutoPatrolScheduleIndexes,
    setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean,
    setUpdatedAutoPatrolScheduleHealthchckMetricsIds,
  } = useSiteAboutStore.getState();

  const backupAutoPatrolMetrics = localStorage.getItem(
    BACKUP_AUTO_PATROL_SCHEDULE_HEALTHCHCK_METRICS
  );
  if (backupAutoPatrolMetrics) {
    setAutoPatrolScheduleHealthchckMetrics(JSON.parse(backupAutoPatrolMetrics));
  }

  const backupAutoPatrol = localStorage.getItem(BACKUP_AUTO_PATROL_SCHEDULES);
  if (backupAutoPatrol) {
    setAutoPatrolSchedules(JSON.parse(backupAutoPatrol));
  }

  const backupCameraProducts = localStorage.getItem(
    BACKUP_AUTO_PATROL_CAMERA_PRODUCTS
  );
  if (backupCameraProducts) {
    setAutoPatrolCameraProducts(JSON.parse(backupCameraProducts));
  }

  const backupProductMetricsIds = localStorage.getItem(
    BACKUP_UPDATED_PRODUCT_METRICS_IDS
  );
  if (backupProductMetricsIds) {
    setUpdatedProductMetricsIds(JSON.parse(backupProductMetricsIds));
  }

  setProductMetricsWereUpdated(false);
  setAutoPatrolSchedulesUpdatedBoolean(false);
  setUpdatedAutoPatrolScheduleIndexes([]);
  setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean(false);
  setUpdatedAutoPatrolScheduleHealthchckMetricsIds([]);

  setSchedulesEditMode(false);
};
